import { message } from 'antd';
/**
 * @author: leroy
 * @date: 2021/11/3 11:22
 * @description：Home
 */
import { makeAutoObservable, runInAction } from 'mobx';
import { getExamDetail, getExamList } from '@/store/services/exam';
import moment from 'moment';

export class HomeStore {
  examDetail: ExamType.ExamDetailData = {} as ExamType.ExamDetailData;
  examList?: ExamType.ExamListType.ListData;
  examId?: string;
  hideLogoId = ['51QR90N69L2LNZLDVE', 'VMOQ1EK99W72KG2D86'];
  AllRouters = ['camera', 'microphone', 'screenSharing', 'mobileDevice', 'signature'];

  // hideLogoId = '81J0GENVOD6JK2ZW74';

  constructor() {
    makeAutoObservable(this);
    // makeLoggable(this);
  }

  setData({ key, value }: { key: keyof HomeStore; value: any }) {
    // @ts-ignore
    this[key] = value;
  }

  hydrate = (data) => {
    if (!data) return;
    Object.entries(data).forEach(([key, value]) => {
      this[key] = value;
    });
  };

  fetchExamDetail = async ({ id, anid }: { id; anid? }) => {
    try {
      const { data, msg } = await getExamDetail({ id, anid });
      if (!data && msg) message.warning(msg);
      runInAction(() => {
        this.examDetail = data!;
        this.examId = data?.id;
      });
      return data;
    } catch (e) {
      console.log(e);
    }
  };

  fetchList = async (params) => {
    try {
      const { data } = await getExamList(params);
      runInAction(() => {
        this.examList = data;
      });
      return data;
    } catch (error) {
      console.log('fetchList', error);
    }
  };

  get getEndTime() {
    if (this.examDetail) {
      return moment(this.examDetail?.userData?.create_time || new Date())
        .add(this.examDetail?.time, 'm')
        .format('YYYY-MM-DD HH:mm:ss');
    }
  }

  get examLogoConfig() {
    if (!this.examDetail.id) return null;
    return {
      is_enterprise_logo: this.examDetail.is_enterprise_logo,
      ico_name: this.examDetail.ico_name,
      systemLogo: this.examDetail.systemLogoPath,
    };
  }

  get examConfig() {
    return {
      canPaste: !!this.examDetail.is_paste,
      canCopy: !!this.examDetail.is_copy_question,
      canUpload: !!this.examDetail.is_upload_file,
      cutTimes: this.examDetail.cutting_times,
      monitorJumoRouters: {
        camera: !!this.examDetail.is_skip_camera,
        microphone: !!this.examDetail.is_skip_microphone,
        screenSharing: !!this.examDetail.is_skip_screen,
        mobileDevice: !!this.examDetail.is_skip_phone,
        signature: false,
      },
      monitorClosedPageRouters: {
        camera: this.examDetail.is_close_camera,
        microphone: this.examDetail.is_close_microphone,
        screenSharing: this.examDetail.is_close_screen,
        mobileDevice: this.examDetail.is_close_phone,
        // camera: 1,
        // microphone: 1,
        // screenSharing: 1,
        // mobileDevice: 0,
      },
    };
  }

  get filterRouters() {
    return this.AllRouters.filter((item) => !this.examConfig.monitorClosedPageRouters[item]);
  }
}

export default HomeStore;
